export const TRANSLATIONS_REQUESTS = {
  table: {
    hero: {
      title: 'global.requests.main',
      description: 'requests.hero.description_empty_state'
    },
    status: {
      all: 'global.all_female.main',
      pending: 'status.pending',
      active: 'status.approved_female',
      rejected: 'status.rejected_female',
      cancelled: 'status.ended_female'
    },
    header: {
      member: 'global.collaborators_title',
      type: 'global.type',
      amount: 'rf.global.amount.main',
      requestDate: 'global.request_date.main',
      status: 'global.status'
    },
    emptyState: {
      title: 'requests.table.empty_state.title',
      description: 'requests.table.empty_state.description'
    },
    filter: {
      title: 'requests.filter_menu.title',
      all: 'global.all_female.main',
      training: 'global.rf.benefit_title.learning',
      health: 'global.rf.benefit_title.health_insurance'
    }
  },
  details: {
    hero: {
      title: 'requests.request_detail.header.title',
      description: 'requests.request_detail.header.description'
    },
    deductionsCard: {
      title: 'requests.request_detail.payroll_deduction_card.title',
      totalAmount: 'rf.global.total_amount',
      deductionPerPayroll: 'rf.global.deduction_per_payroll.main',
      equalSplitDescription: 'rf.global.equal_deduction_division.action_description',
      amountInputPlaceholder: 'rf.global.enter_amount.main',
      approveButton: 'global.button.approve_request',
      rejectButton: 'global.button.reject_request',
      cancelButton: 'requests.course_request_approved.button.cancel_course',
      emptyInputsTooltip: 'requests.request_detail.error_tooltip.empty_amount',
      invalidAmountsTooltip: 'requests.request_detail.error_tooltip.incorrect_amount',
      moreInfoButton: 'rf.global.how_payroll_deduction_work.main'
    },
    material: {
      title: 'requests.request_detail.request_details_card.title',
      collaboratorLabel: 'global.collaborators_title',
      materialLabel: 'requests.global.educational_training_name.main',
      typeLabel: 'global.type',
      descriptionLabel: 'global.description.main'
    },
    course: {
      title: 'requests.request_detail.request_details_card.title',
      collaboratorLabel: 'global.collaborators_title',
      trainingLabel: 'requests.global.educational_training_name.main',
      typeLabel: 'global.type',
      datesLabel: 'global.start_and_end_date.main',
      descriptionLabel: 'global.description.main',
      infoBanner: 'requests.course_request_detail.request_details_card.info_banner',
      trainingCenterLabel: 'global.educational_training_center.main',
      nameLabel: 'global.name.main',
      contactPersonLabel: 'global.contact_person.main',
      contactDataLabel: 'global.contact_data.main',
      tooltip: 'requests.course_request_detail.request_details_card.ended_status.tooltip'
    },
    insurance: {
      title: 'requests.request_detail.request_details_card.title',
      collaboratorLabel: 'global.collaborators_title',
      identificationLabel: 'rf.global.dni_nie.label',
      genderLabel: 'global.gender.main',
      birthDateLabel: 'global.date_of_birth_main',
      emailLabel: 'global.email.main',
      phoneLabel: 'global.phone.main',
      addressLabel: 'global.address.main',
      infoBanner: 'requests.health_insurance_request_detail.request_details_card.info_banner',
      companyNameLabel: 'global.insurance_company.main',
      policyNumberLabel: 'global.policy.main',
      healthInsuranceLabel: 'global.health_insurance._main',
      notInformed: 'global.not_informed.main'
    },
    insuranceDiscounts: {
      title: 'requests.request_detail.payroll_deduction_card.title',
      description: 'requests.health_insurance_request_detail.payroll_deduction_card.description',
      linkLabel: 'rf.global.how_payroll_deduction_work.main',
      totalAmountLabel: 'rf.global.monthly_amount',
      startDateLabel: 'global.start_date.main',
      expirationDateLabel: 'global.expiration_date.main',
      globalDatePlaceholder: 'global.date.placeholder',
      dateFormatError: 'global.error_hint.date_format',
      expirationDateError: 'rf.requests.health_insurance.error_hint.earlier_expiration_date',
      startDateError: 'rf.requests.health_insurance.error_hint.late_start_date',
      dateError: 'add_collaborators.error_hint.over_120y',
      tooltipError: 'requests.request_detail.error_tooltip.empty_start_date',
      approveButton: 'global.button.approve_request',
      rejectButton: 'global.button.reject_request',
      cancelButton: 'global.button.end_insurance'
    },
    materialDiscounts: {
      title: 'requests.request_detail.payroll_deduction_card.title',
      linkLabel: 'rf.global.how_payroll_deduction_work.main',
      totalAmountLabel: 'rf.global.total_amount',
      paymentMonthLabel: 'rf.global.payroll_deducticon_month.main'
    },
    modals: {
      approve: {
        title: 'requests.approve_request.confirmation_dialog.title',
        description: 'requests.approve_request.confirmation_dialog.description',
        primaryButton: 'requests.approve_request.confirmation_dialog.button.approve_request',
        secondaryButton: 'button.close',
        primaryButtonLoadingText: 'requests.approve_request.confirmation_dialog.button.loading'
      },
      reject: {
        title: 'requests.reject_request.confirmation_dialog.title',
        description: 'requests.reject_request.confirmation_dialog.description',
        primaryButton: 'requests.reject_request.confirmation_dialog.button.reject_request',
        secondaryButton: 'button.close'
      },
      cancel: {
        title: 'requests.cancel_course.confirmation_dialog.title',
        healthTitle: 'requests.cancel_insurance.confirmation_dialog.title',
        description: 'requests.cancel_course.confirmation_dialog.description',
        primaryButton: 'requests.cancel_course.confirmation_dialog.button.cancel_course',
        healthPrimaryButton: 'global.button.end_insurance',
        secondaryButton: 'button.close'
      },
      errors: {
        common: {
          title: 'requests.validation_error.dialog.title',
          button: 'button.understood'
        },
        salaryPercentage: {
          description: 'requests.validation_error.dialog.salary_percentage_excedeed.description'
        },
        accumulationLimit: {
          description: 'requests.validation_error.dialog.accumulation_limit_excedeed.description'
        },
        SMIThreshold: {
          description: 'requests.validation_error.dialog.smi_threshold_violation.description'
        },
        internalFRError: {
          title: 'requests.internal_error.dialog.title',
          description: 'requests.internal_error.dialog.description',
          buttonPrimary: 'global.button.contact_support',
          buttonSecondary: 'button.close'
        }
      }
    },
    rejectReasons: {
      salaryPercentage: 'requests.request_detail.rejected_banner.salary_percentage_excedeed',
      accumulationLimit: 'requests.request_detail.rejected_banner.accumulation_limit_excedeed',
      SMIThreshold: 'requests.request_detail.rejected_banner.smi_threshold_violation',
      internalFRError: 'requests.request_detail.rejected_banner.internal_error'
    }
  }
};
